module.exports = __webpack_public_path__ + "img/page_3_1.178538c4.png";